/* Tysk katalog for locale-bank-misc-no.js (del 3 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'bank.guided.tabHandling': 'Zu bearbeiten · {{count}}',
  'bank.guided.tabDeviation': 'Verursacht Abweichung · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} gebuchte Posten verursachen eine Abweichung',
  'bank.guided.linkHelp': 'Verknüpfe eine Quittung oder Rechnung mit dem Kauf. Gibt es keine Dokumentation, wähle „Ohne Beleg“, damit die Auswahl gespeichert und später geprüft werden kann.',
  'bank.guided.purchasesMissing': '{{count}} Käufe ohne Beleg.',
  'bank.guided.noneMissing': 'Es fehlen keine Belege.',
  'bank.guided.ctl.allHandled': 'Alle Zahlungen sind bearbeitet',
  'bank.guided.ctl.remaining': '{{count}} übrig',
  'bank.guided.ctl.vouchersLinked': 'Erforderliche Belege sind verknüpft',
  'bank.guided.ctl.missingVouchers': '{{count}} ohne Beleg',
  'bank.guided.ctl.statementBalances': 'Die Salden des Kontoauszugs stimmen',
  'bank.guided.ctl.deviation': 'Abweichung {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Gebuchter Banksaldo stimmt',
  'bank.guided.ctl.clear': 'Bereit',
  'bank.guided.finishNote': 'Wenn du abschließt, prüft Plumme die Salden, sperrt den Zeitraum und verschiebt den Kontoauszug ins Archiv.',
  'bank.guided.allChecked': 'Alles ist geprüft und bereit.',
  'bank.guided.resolveToFinish': 'Kläre die Punkte oben, um den Abschluss freizuschalten.',
  'bank.guided.toast.noPending': 'Keine Vorschläge warten auf Bestätigung.',
  'bank.guided.superLinks': 'SuperPlumma verknüpft',
  'bank.guided.approveSuggestions': 'Vorschläge bestätigen',
  'bank.guided.note.tapPurchase': 'Tippe auf einen Beleg und dann auf den Kauf, mit dem du ihn verknüpfen möchtest.',
  'bank.guided.note.tapSuggestion': 'Tippe auf einen Beleg und dann auf den Vorschlag. Mögliche Treffer werden in der Liste markiert.',
  'bank.guided.note.dragPurchase': 'Ziehe einen Beleg auf den Kauf, mit dem du ihn verknüpfen möchtest.',
  'bank.guided.note.dragSuggestion': 'Ziehe einen Beleg auf einen Vorschlag. Mögliche Treffer werden in der Liste markiert.',
  'bank.guided.err.checkImportFirst': 'Prüfe zuerst den Importübergang.',
  'bank.guided.toast.postingVoided': 'Die Buchung wurde storniert',
  'bank.guided.archiving': 'Wird archiviert…',
  'bank.guided.archiveNote': 'Die Kontrolle wird gesperrt und ins Archiv verschoben. Die Bankzeilen wurden bereits bei der Bestätigung gebucht.',
  'bank.archive.lockedNote': 'Die Abstimmung ist gesperrt. Klappe eine Zeile auf, um Beleg und Buchung zu sehen. Konto, MwSt. und interne Beschreibung können korrigiert werden, ohne den Bankbetrag zu ändern.',
  'bank.archive.searchPh': 'Buchungen durchsuchen',
  'bank.archive.searchHelp': 'Suche nach Datum, Beschreibung, Betrag, Konto oder Beleg.',
  'bank.archive.countOf': '{{shown}} von {{total}} Buchungen',
  'bank.archive.handled': 'Bearbeitet',
  'bank.archive.code': 'Code {{code}}',
  'bank.archive.auditTrail': 'Prüfpfad',
  'bank.archive.correctionsOne': '{{count}} Korrektur',
  'bank.archive.correctionsMany': '{{count}} Korrekturen',
  'bank.archive.noCorrections': 'Keine Korrekturen',
  'bank.archive.internalDescription': 'Interne Beschreibung',
  'bank.archive.noVoucher': 'Kein Beleg verknüpft',
  'bank.archive.noMatch': 'Keine Buchungen entsprechen der Suche oder den Filtern.',
  'bank.archive.err.correctFailed': 'Die Buchung konnte nicht korrigiert werden.',
  'bank.importFix.err.openFirst': 'Öffne die Verknüpfung oder die Buchung, bevor die Auslesung korrigiert wird.',
  'bank.importFix.err.reasonLine': 'Gib kurz an, warum die Bankzeile korrigiert wird.',
  'bank.importFix.err.amountNumber': 'Der Betrag muss eine Zahl sein.',
  'bank.importFix.removeFromRecon': 'Zeile ignorieren',
  'bank.importFix.warnTitle': 'Nur verwenden, wenn die PDF/CSV falsch ausgelesen wurde.',
  'bank.importFix.warnBody': 'Dies ändert weder die Bank noch gebuchte Belege. Die Originalwerte bleiben im Verlauf erhalten.',
  'bank.importFix.blocked': 'Die Zeile ist bereits verknüpft oder gebucht. Öffne die Verknüpfung/Buchung, bevor die Auslesung selbst korrigiert wird.',
  'bank.importFix.originalRead': 'Ursprünglich ausgelesen',
  'bank.importFix.effect': 'Auswirkung auf die Abstimmung',
  'bank.importFix.deviationNow': 'Abweichung jetzt:',
  'bank.importFix.afterCorrection': 'Nach der Korrektur:',
  'bank.importFix.stillDeviates': 'Bleibt die Abweichung bestehen, prüfe, ob auch AB/EB falsch ausgelesen wurden.',
  'bank.importFix.fixLine': 'Zeile korrigieren',
  'bank.importFix.removeMisread': 'Zeile ignorieren',
  'bank.ignoreLine': 'Zeile ignorieren',
  'bank.ignoreLineHelp': 'Verwende dies nur, wenn die Zeile falsch ausgelesen wurde und nicht im Kontoauszug steht. Die Zeile bleibt im Verlauf erhalten.',
  'bank.ignoreLineConfirm': 'Zeile ignorieren',
  'bank.ignoreLineReason': 'Warum wird die Zeile ignoriert?',
  'bank.ignoreLineReasonHint': 'Für den Prüfpfad erforderlich.',
  'bank.ignoreLineReasonPlaceholder': 'Z. B. die Zeile steht nicht im Kontoauszug',
  'bank.importFix.removeNote': 'Die Zeile bleibt im Verlauf, zählt aber als 0,00 kr und gilt in der Abstimmung als erledigt. Nur verwenden, wenn die Zeile nicht im Kontoauszug steht.',
  'bank.importFix.whyReading': 'Warum wird die Auslesung korrigiert?',
  'bank.importFix.whyReadingPh': 'Z. B. OCR hat einen falschen Betrag gelesen / die Zeile steht nicht im Kontoauszug',
  'bank.importFix.err.balancesNumber': 'AB und EB müssen Zahlen sein.',
  'bank.importFix.err.reasonBalance': 'Gib kurz an, warum der Saldo korrigiert wird.',
  'bank.importFix.saveBalance': 'Saldo speichern',
  'bank.importFix.balanceWarnTitle': 'Nur ändern, wenn der Saldo aus Kontoauszug/Import falsch ist.',
  'bank.importFix.balanceWarnBody': 'Der AB wird normalerweise aus dem letzten abgestimmten EB übernommen. Der ursprünglich ausgelesene Saldo bleibt erhalten.',
  'bank.importFix.resultPrefix': 'Mit den aktuell bearbeiteten Bankzeilen beträgt die Saldoabweichung',
  'bank.importFix.whyBalance': 'Warum wird der Saldo korrigiert?',
  'bank.importFix.whyBalancePh': 'Z. B. der EB wurde aus der falschen Zeile der PDF gelesen',
  'bank.loan.intro': 'Verwende dies für Darlehensaufnahmen, Tilgungen oder Zahlungen, die in Tilgung, Zinsen und Gebühren aufgeteilt werden können. Das gewählte Konto stammt aus dem aktiven Kontenplan des Unternehmens, und die Buchung erfolgt ohne MwSt.',
  'bank.loan.account': 'Darlehens-/Verbindlichkeitskonto',
  'bank.loan.noAccount': 'Im aktiven Kontenplan wurde kein normales Darlehens-/Verbindlichkeitskonto gefunden. Lege das richtige Konto an oder verwende eine freie Buchung.',
  'bank.loan.principal': 'Tilgung / Darlehensbetrag',
  'bank.loan.splitMismatch': 'Die Aufteilung muss dem Bankbetrag entsprechen. Rest: {{amount}} kr.',
  'bank.loan.docLinked': 'Dokumentation ist verknüpft.',
  'bank.loan.docRemember': 'Denk an die Dokumentation.',
  'bank.loan.docHelp': 'Lade Darlehensvertrag, Tilgungsplan oder andere Unterlagen hoch. Die Aufteilung muss belegbar sein.',
  'bank.loan.complex': 'Betrifft die Zeile nahestehende Personen, ein ungewöhnliches Konto oder ein komplizierteres Darlehensverhältnis?',
  'bank.loan.useFree': 'Freie Buchung verwenden',
  'bank.group.err.sameDirection': 'Alle Bankzeilen in einer Aufteilungsgruppe müssen dieselbe Richtung haben.',
  'bank.group.err.pickBoth': 'Wähle beide Bankzeilen der Überweisung aus.',
  'bank.group.toast.transferApproved': 'Die Überweisung wurde genehmigt und gemeinsam gebucht.',
  'bank.group.toast.allocationApproved': 'Die Aufteilung wurde genehmigt und gemeinsam gebucht.',
  'bank.group.err.approveFailed': 'Die Zuordnungsgruppe konnte nicht genehmigt werden.',
  'bank.group.title': 'Mehrere Bankvorgänge zuordnen',
  'bank.group.approve': 'Gruppe genehmigen und buchen',
  'bank.group.oneOperation': 'Ein kontrollierter Vorgang',
  'bank.group.oneOperationHelp': 'Die Gruppe reserviert alle ausgewählten Bankzeilen. Buchung und Verknüpfung erfolgen gemeinsam im Backend, wenn du genehmigst.',
  'bank.group.matchType': 'Art der Zuordnung',
  'bank.group.typeAllocation': 'Zahlung auf offene Posten aufteilen',
  'bank.group.typeTransfer': 'Interne Überweisung zwischen eigenen Konten',
  'bank.group.sourceLine': 'Zeile von einem Konto',
  'bank.group.counterLine': 'Gegenbuchung auf eigenem Konto',
  'bank.group.pickOpposite': 'Gegenläufige Bankzeile auswählen',
  'bank.group.transferRules': 'Angeboten werden nur gleiches Datum und gleicher Betrag, entgegengesetztes Vorzeichen und ein anderes eingerichtetes Bankkonto. Unterschiedliche Daten erfordern ein Transitkonto.',
  'bank.group.noOpenItems': 'Keine offenen {{kind}} können zugeordnet werden.',
  'bank.group.customerInvoices': 'Kundenrechnungen',
  'bank.group.supplierInvoices': 'Lieferantenrechnungen',
  'bank.group.itemRest': '{{number}} · {{party}} · Rest {{amount}}',
  'bank.group.removeRow': 'Zeile entfernen',
  'bank.corr.err.reasonVoid': 'Gib kurz an, warum die Buchung storniert wird.',
  'bank.corr.err.notFieldCorrectable': 'Diese Buchungsart kann nicht feldweise aus der Bankabstimmung korrigiert werden. Storniere die Buchung und buche sie neu, oder öffne den Beleg im Belegjournal.',
  'bank.corr.err.supplierPaymentVoid': 'Zahlungen von Lieferantenrechnungen werden über den Lieferantenbeleg storniert.',
  'bank.corr.err.noSupportedAction': 'Für diese gebuchte Position wurde keine unterstützte Aktion gefunden.',
  'bank.receipt.toast.trashed': 'Der Beleg wurde in den Papierkorb verschoben.',
  'bank.receipt.err.deleteFailed': 'Der Beleg konnte nicht gelöscht werden.',
  'bank.receipt.deleting': 'Wird gelöscht…',
  'bank.receipt.delete': 'Beleg löschen',
  'bank.mode.toFull': 'Zur Gesamtübersicht wechseln',
  'bank.mode.toGuided': 'Zu Schritt für Schritt wechseln',
  'bank.import.toast.privateSaved': 'Privatauszug gespeichert - bereit zur Prüfung',
  'bank.import.toast.saved': 'Kontoauszug gespeichert - bereit zur Abstimmung',
  'bank.inbox.view.statement': 'Dieser Auszug',
  'bank.inbox.view.unlinked': 'Nur nicht verknüpfte',
  'bank.inbox.view.all': 'Alle Belege',
  'bank.inbox.showInList': 'Im Posteingang anzeigen',
  'bank.inbox.viewing': 'Anzeige: {{view}} · {{hidden}} ausgeblendet',
  'bank.inbox.waiting': '{{count}} Belege warten auf Bearbeitung',
  'bank.inbox.hide': 'Posteingang ausblenden',
  'bank.inbox.companyAddress': 'den Belegeingang des Unternehmens',
  'bank.inbox.defaultNote': 'Zieh einen Beleg auf eine Bankzeile oder lass SuperPlumma Treffer vorschlagen.',
  'bank.inbox.uploadVoucher': 'Beleg hochladen',
  'bank.inbox.orDrag': 'Oder ziehen · auf einer Zeile ohne Beleg ablegen',
  'bank.inbox.dropHint': 'Dateien hier ablegen, um neue Belege hochzuladen.',
  'bank.inbox.noMatch': 'Keine Belege entsprechen der Suche.',
  'bank.inbox.noneInSelection': 'Keine Belege in dieser Auswahl · {{hidden}} durch den Filter ausgeblendet',
  'bank.inbox.allDone': 'Alle Belege sind bearbeitet',
  'bank.inbox.empty': 'Der Posteingang ist leer',
  'bank.inbox.tip.showAll': 'Klicke, um wieder alle Bankzeilen anzuzeigen',
  'bank.inbox.tip.showLine': 'Klicke, um die Bankzeile anzuzeigen, mit der dieser Beleg verknüpft ist',
  'bank.inbox.tip.linkedElsewhere': 'Außerhalb dieses Kontoauszugs verknüpft',
  'bank.inbox.linkedHere': 'Verknüpft · {{label}}',
  'bank.inbox.linkedIn': 'Verknüpft in {{label}}',
  'bank.inbox.previewName': 'Vorschau {{name}}',
  'bank.inbox.voucherLower': 'Beleg',
  'bank.inbox.filteredOne': 'Gefiltert auf einen Beleg',
  'bank.inbox.filteredN': 'Gefiltert auf {{count}} Belege',
  'bank.inbox.filterShowsLinked': 'Zeigt nur die Bankzeilen, mit denen die Belege verknüpft sind',
  'bank.inbox.showAllLines': 'Alle Zeilen anzeigen',
  'bank.inbox.nBankLines': '{{count}} Bankzeilen',
  'bank.inbox.bankLineLower': 'Bankzeile',
  'bank.inbox.anotherStatement': 'einem anderen Kontoauszug',
  'bank.inbox.toast.linkedElsewhere': 'Der Beleg ist mit einer Bankzeile in {{label}} verknüpft.',
  'bank.resolve.annulText': 'Die Position ist doppelt gebucht. Storniere sie, damit sie nicht mitzählt. Ein eventueller Beleg wird automatisch in den Posteingang zurückgelegt.',
  'bank.resolve.correctText': 'Die Buchung soll bestehen bleiben, aber Konto, MwSt. oder interne Beschreibung sind falsch. Bankbetrag und Datum bleiben gesperrt.',
  'bank.resolve.err.voidFailed': 'Die gebuchte Position konnte nicht storniert werden.',
  'bank.resolve.voiding': 'Wird storniert…',
  'bank.resolve.confirmVoid': 'Stornierung bestätigen',
  'bank.resolve.voidReason': 'Grund der Stornierung',
  'bank.resolve.voidReasonHint': 'Pflichtfeld. Die Begründung wird im Prüfpfad gespeichert.',
  'bank.resolve.voidReasonPh': 'Beschreibe kurz, warum die Buchung storniert werden soll',
  'bank.resolve.row.postedEntry': 'Gebuchte Position',
  'bank.resolve.row.account': 'Konto',
  'bank.resolve.row.vat': 'MwSt.',
  'bank.resolve.row.amount': 'Betrag',
  'bank.resolve.row.lineDate': 'Datum der Bankzeile',
  'bank.resolve.row.bankLine': 'Bankzeile',
  'bank.resolve.row.voucher': 'Beleg',
  'bank.resolve.row.notLinked': 'Nicht verknüpft',
  'bank.resolve.reopenAsDeviation': 'Als Abweichung öffnen',
  'bank.resolve.releaseInvestmentMatch': 'Bankverknüpfung lösen',
  'bank.resolve.reverse': 'Stornieren',
  'bank.resolve.alreadyPosted': 'Diese Bankzeile ist bereits gebucht oder zugeordnet. Sie kann daher nicht als neue Zeile bearbeitet werden.',
  'bank.resolve.useCorrection': 'Verwende die Korrektur für Konto, MwSt. oder interne Beschreibung. Bankbetrag, Datum und Verknüpfung bleiben gesperrt.',
  'bank.resolve.reverseInfo': 'Die Stornierung hebt den Einkauf nachvollziehbar auf und öffnet die Bankzeile für eine erneute Prüfung.',
  'bank.resolve.existingInfo': 'Dies ist mit einem bestehenden Beleg oder einer bestehenden Position verknüpft. Korrigiere den Beleg selbst, wenn die Grundlage falsch ist.',
  'bank.resolve.verifiableInfo': 'Diese Verknüpfung kann in den Positionsdetails nachvollzogen werden.',
  'bank.resolve.approving': 'Wird genehmigt…',
  'bank.resolve.approveN': '{{count}} Vorschläge genehmigen',
  'bank.resolve.confirmIntro': 'Prüfe die Zusammenfassung. Vorschläge, die einer bestehenden Position zugeordnet sind, erzeugen keine neue Buchung.',
  'bank.resolve.voucherReturns': 'Der Beleg „{{name}}“ wird automatisch in den Posteingang zurückgelegt, wenn die Position storniert wird.',
  'bank.err.uploadVoucherFailed': 'Der Beleg konnte nicht hochgeladen werden.',
  'bank.drop.attachAsDoc': 'Wird als Dokumentation angehängt',
  'bank.drop.uploadAnalyzeLink': 'Wird hochgeladen, analysiert und verknüpft',
  'bank.receipt.confirmDelete': 'Beleg aus dem Posteingang löschen? Er wird in den Papierkorb verschoben und kann wiederhergestellt werden.',
  'bank.percentDone': '{{pct}}% erledigt',
  'mypage.role.owner': 'Inhaber',
  'mypage.role.admin': 'Administrator',
  'mypage.role.accountant': 'Buchhalter',
  'mypage.role.viewer': 'Leser',
  'mypage.shortcut.oversikt.title': 'Übersicht',
  'mypage.shortcut.oversikt.text': 'Gesundheitswert und finanzielle Übersicht für den Haushalt',
  'mypage.shortcut.forbruk.title': 'Ausgaben',
  'mypage.shortcut.forbruk.text': 'Wofür das Geld ausgegeben wird, nach Kategorien',
  'mypage.shortcut.familie.title': 'Familie',
  'mypage.shortcut.familie.text': 'Gemeinsames Budget und Aufteilung im Haushalt',
  'mypage.shortcut.fremtid.title': 'Zukunft',
  'mypage.shortcut.fremtid.text': 'Sparen, Kredite, Rente und Zukunftspläne',
  'mypage.shortcut.skatt.title': 'Steuern',
  'mypage.shortcut.skatt.text': 'Private skattemelding, Abzüge und Schätzung',
  'mypage.fallback.business': 'Unternehmen',
  'mypage.fallback.signedInUser': 'Angemeldeter Benutzer',
  'mypage.fallback.employerLoadError': 'Arbeitgeber konnten nicht geladen werden.',
  'mypage.verify.body': 'Einige Funktionen, darunter Mandanteneinladungen und das Mitarbeiterportal, erfordern, dass {{email}} bestätigt ist. Sende den Link erneut, falls du ihn nicht findest, öffne den Link in der E-Mail und bestätige anschließend hier.',
  'mypage.verify.resend': 'Bestätigung erneut senden',
  'mypage.verify.sending': 'Wird gesendet...',
  'mypage.verify.confirmed': 'Ich habe bestätigt',
  'mypage.verify.checking': 'Wird geprüft...',
  'mypage.err.profileNotConnected': 'Das Speichern des Profils ist nicht mit dem Backend verbunden.',
  'mypage.toast.profileUpdated': 'Das Profil wurde aktualisiert',
  'mypage.err.profileUpdateFailed': 'Das Profil konnte nicht aktualisiert werden.',
  'mypage.err.verifyNotConnected': 'Die E-Mail-Bestätigung ist nicht mit dem Backend verbunden.',
  'mypage.toast.alreadyVerified': 'Die E-Mail-Adresse ist bereits bestätigt.',
  'mypage.toast.verifyResent': 'Der Bestätigungslink wurde erneut gesendet.',
  'mypage.err.verifySendFailed': 'Der Bestätigungslink konnte nicht gesendet werden.',
  'mypage.err.verifyStatusFailed': 'Der E-Mail-Status konnte nicht geprüft werden.',
  'mypage.toast.emailVerified': 'Die E-Mail-Adresse ist bestätigt.',
  'mypage.toast.stillUnverified': 'Die Adresse ist noch nicht bestätigt. Prüfe deinen Posteingang und versuche es erneut.',
  'mypage.err.personalNotConnected': 'Privatfinanzen sind in diesem Build nicht mit dem Backend verbunden.',
  'mypage.toast.personalCreated': 'Privatfinanzen wurden angelegt',
  'mypage.err.personalCreateFailed': 'Privatfinanzen konnten nicht angelegt werden.',
  'mypage.toast.openPersonalForFamily': 'Öffne Privatfinanzen, um Familie zu ändern.',
  'mypage.toast.familyEnabled': 'Familie ist aktiviert.',
  'mypage.toast.familyDisabled': 'Familie ist deaktiviert.',
  'mypage.err.familySaveFailed': 'Die Familie-Einstellung konnte nicht gespeichert werden.',
  'mypage.titleHelp': 'Meine Seite ist dein persönliches Konto in Plumme – getrennt von den Buchhaltungen selbst. Hier siehst du dein Profil, die Unternehmen, auf die du Zugriff hast, die Arbeitgeber, bei denen du angestellt bist, und den Zugang zu deinen Privatfinanzen.',
  'mypage.field.memberSince': 'Mitglied seit',
  'mypage.toast.onboardingNotLoaded': 'Das Onboarding ist noch nicht geladen.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Unternehmen werden geladen',
  'mypage.biz.loadingText': 'Verbindung zum Plumme-Backend wird hergestellt.',
  'mypage.biz.emptyTitle': 'Keine eigenen Unternehmen',
  'mypage.biz.emptyText': 'Du kannst hier später ein Unternehmen anlegen, auch wenn du Plumme nur als Buchhalter oder Privatnutzer verwendest.',
  'mypage.clients.title': 'Mandantenaufträge',
  'mypage.clients.help': 'Unternehmen, zu denen du als Buchhalter, Administrator oder Leser eingeladen bist. Mandantendaten werden getrennt von eigenen Unternehmen und Privatfinanzen gehalten.',
  'mypage.clients.setup': 'Buchhalter-Einrichtung',
  'mypage.clients.access': 'Mandantenzugriff',
  'mypage.clients.empty': 'Du hast keine aktiven Mandantenaufträge. Einladungen werden nach der Anmeldung global angezeigt.',
  'mypage.pf.creating': 'Wird angelegt...',
  'mypage.pf.create': 'Privatfinanzen anlegen',
  'mypage.pf.intro': 'Dein persönlicher Berater für die Haushaltsfinanzen - getrennt von der Buchhaltung der Unternehmen. Wähle eine Übersicht, um loszulegen.',
  'mypage.pf.family': 'Familie',
  'mypage.pf.familyText': 'Familie-Seite in Privatfinanzen anzeigen.',
  'mypage.pf.emptyIntro': 'Lege einen Privatfinanzen-Mandanten an, um private Übersicht, Import, Haushalt, Steuern und Berichte zu bündeln, ohne sie mit den Buchhaltungsmandanten zu vermischen.',
  'mypage.emp.fallbackRole': 'Mitarbeiter',
  'mypage.emp.loadingTitle': 'Arbeitgeber werden geladen',
  'mypage.emp.emptyTitle': 'Keine Arbeitgeber',
  'mypage.emp.loadingText': 'Verbindung zum Mitarbeiterportal wird hergestellt.',
  'mypage.emp.emptyText': 'Für den Benutzer sind keine Zugänge zum Mitarbeiterportal registriert.',
  'mypage.err.passwordResetNotConnected': 'Das Zurücksetzen des Passworts ist nicht mit dem Backend verbunden.',
  'mypage.toast.passwordLinkSent': 'Ein Link zum Ändern des Passworts wurde per E-Mail gesendet',
  'mypage.err.passwordLinkFailed': 'Der Passwort-Link konnte nicht gesendet werden.',
  'mypage.saving': 'Wird gespeichert...',
  'mypage.hh.loadError': 'Die Haushaltsverknüpfung konnte nicht geladen werden.',
  'mypage.hh.updateError': 'Der Haushalt konnte nicht aktualisiert werden.',
  'mypage.hh.inviteEmailFailed': 'Die Einladung wurde erstellt, aber die E-Mail konnte nicht gesendet werden. Du kannst es erneut versuchen.',
  'mypage.hh.inviteSent': 'Die Einladung wurde erstellt und gesendet.',
  'mypage.hh.left': 'Die Haushaltsverknüpfung wurde beendet.',
  'mypage.hh.hiddenPending': 'Die Einladung wurde zurückgezogen und aus der Liste entfernt.',
  'mypage.hh.hidden': 'Die Einladung wurde aus der Liste entfernt.',
  'mypage.hh.loading': 'Haushaltsstatus wird geladen …',
  'mypage.hh.partnerFallback': 'Verbundener Partner',
  'mypage.hh.twoAccounts': 'Zwei getrennte Konten · gemeinsame Familie-Seite',
  'mypage.hh.leaveConfirm': 'Haushalt trennen? Beide behalten ihre eigenen Daten, während das gemeinsame Familie-Profil beendet wird.',
  'mypage.hh.leaving': 'Wird getrennt …',
  'mypage.hh.leave': 'Haushalt trennen',
  'mypage.hh.inviteIntro': 'Lade einen Partner per E-Mail ein. Die Person kann sich anmelden oder ein neues Plumme-Konto erstellen und erhält Hilfe beim Anlegen der Privatfinanzen, bevor die Verknüpfung bestätigt wird.',
  'mypage.hh.inviting': 'Wird erstellt …',
  'mypage.hh.invite': 'Partner einladen',
  'mypage.hh.userFallback': 'Plumme-Benutzer',
  'mypage.hh.joined': 'Der Haushalt wurde verknüpft.',
  'mypage.hh.sentInvites': 'Gesendete Einladungen',
  'mypage.hh.resendFailedToast': 'Die Einladung ist aktiv, aber die E-Mail konnte nicht gesendet werden.',
  'mypage.hh.resentToast': 'Die Einladung wurde erneut gesendet.',
  'mypage.hh.resend': 'Erneut senden',
  'mypage.hh.remind': 'Erinnern',
  'mypage.hh.withdrawn': 'Die Einladung wurde zurückgezogen.',
  'mypage.hh.removeFromList': 'Aus der Liste entfernen',
  'mypage.hh.status.pending': 'Wartet auf Antwort · {{delivery}}',
  'mypage.hh.status.expired': 'Abgelaufen',
  'mypage.hh.status.declined': 'Abgelehnt',
  'mypage.hh.status.canceled': 'Zurückgezogen',
  'mypage.hh.status.accepted': 'Angenommen',
  'mypage.hh.delivery.delivered': 'E-Mail zugestellt',
  'mypage.hh.delivery.opened': 'E-Mail geöffnet',
  'mypage.hh.delivery.clicked': 'Link geöffnet',
  'mypage.hh.delivery.failed': 'E-Mail fehlgeschlagen',
  'mypage.hh.delivery.bounced': 'E-Mail abgewiesen',
  'mypage.hh.delivery.complained': 'als Spam markiert',
  'mypage.hh.delivery.delivery_delayed': 'E-Mail verzögert',
  'mypage.hh.delivery.sent': 'E-Mail gesendet',
  'audit.domain.settings': 'Einstellungen',
  'audit.domain.invoices': 'Rechnungen',
  'audit.domain.sales': 'Verkauf',
  'audit.domain.expenses': 'Einkauf',
  'audit.domain.customers': 'Kunden',
  'audit.domain.products': 'Produkte',
  'audit.domain.suppliers': 'Lieferanten',
  'audit.domain.inbox': 'Posteingang',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Fahrtenbuch',
  'audit.domain.payroll': 'Lohn',
  'audit.domain.business': 'Unternehmen',
  'audit.domain.access': 'Zugriffe',
  'audit.summary.rows': '{{count}} Zeilen',
  'audit.summary.fields': '{{count}} Felder',
  'audit.event.updated': '{{domains}} aktualisiert',
  'audit.event.updatedBusinessData': 'Unternehmensdaten aktualisiert',
  'audit.event.businessCreated': 'Unternehmen angelegt',
  'audit.event.inviteCreated': '{{email}} als {{role}} eingeladen',
  'audit.event.inviteAccepted': '{{user}} hat die Einladung angenommen',
  'audit.event.deletionRequestedFor': 'Löschung des Unternehmens zum {{date}} beantragt',
  'audit.event.deletionRequested': 'Löschung des Unternehmens beantragt',
  'audit.event.deletionCanceled': 'Löschung des Unternehmens abgebrochen',
  'audit.fallback.newUser': 'neuer Benutzer',
  'audit.fallback.userLower': 'Benutzer',
  'audit.fallback.user': 'Benutzer',
  'audit.fallback.unknownUser': 'Unbekannter Benutzer',
  'audit.err.loadFailed': 'Das Aktivitätsprotokoll konnte nicht geladen werden.',
  'audit.meta.time': 'Zeitpunkt',
  'audit.meta.user': 'Benutzer',
  'audit.meta.role': 'Rolle',
  'audit.meta.action': 'Aktion',
  'audit.meta.source': 'Quelle',
  'audit.meta.invite': 'Einladung',
  'audit.meta.targetUser': 'Zielbenutzer',
  'audit.detail.before': 'Vorher:',
  'audit.detail.after': 'Nachher:',
  'audit.titleHelp': 'Das Aktivitätsprotokoll ist ein Prüfprotokoll: Es zeigt alle wichtigen Aktionen in der Buchhaltung - wer was wann und in welchem Bereich getan hat. Nützlich für Nachvollziehbarkeit und Kontrolle, wenn mehrere zusammenarbeiten.',
  'audit.search': 'Aktivitätsprotokoll für {{year}} durchsuchen',
  'audit.scope.all': 'Alle',
  'audit.scope.others': 'Andere',
  'audit.scope.mine': 'Ich',
  'audit.scope.access': 'Zugriffe',
  'audit.col.event': 'Ereignis',
  'audit.empty.loadingTitle': 'Aktivitätsprotokoll wird geladen',
  'audit.empty.loadingText': 'Verbindung zum Plumme-Backend wird hergestellt.',
  'audit.empty.noMatchTitle': 'Keine Treffer',
  'audit.empty.noMatchText': 'Keine Aktivitäten entsprechen dem Filter. Versuche, ihn zurückzusetzen.',
});
